import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function NewsSection() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">
              <a href="#news">新闻资讯</a>
            </h2>
            <p className="text-sm text-foreground-500">最新平台动态与游戏攻略</p>
          </div>
          <Link
            to="/article/a1"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden cursor-pointer hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`九游娱乐${article.title.slice(0, 20)}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-background-50/90 text-foreground-800">
                  {article.category}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-medium text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3">{article.summary}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>
                    <i className="ri-calendar-line mr-1"></i>
                    {article.date}
                  </span>
                  <span>
                    <i className="ri-eye-line mr-1"></i>
                    {article.readCount}阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}